/**
 * csrfTokenを取得する
 */
export async function fetchCsrfToken(): Promise<string> {
  const options: RequestInit = {
    method: 'GET',
    credentials: 'include'
  };
  const result = await fetch('/api/token', options);
  if (!result.ok) {
    throw new Error('fail to get token.');
  }

  try {
    const response: { userToken: string } = await result.json();
    return response.userToken;
  } catch {
    throw new Error('fail to parse json.');
  }
}
